import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const changePackageTransportStatus = createAction(ACTION.CHANGE_PACKAGE_TRANSPORT_STATUS.REQUEST, (packageId) => packageId);
export const beginChangePackageTransportStatus = createAction(ACTION.BEGIN_CHANGE_PACKAGE_TRANSPORT_STATUS, () => {});
export const endChangePackageTransportStatus = createAction(ACTION.END_CHANGE_PACKAGE_TRANSPORT_STATUS, () => {});
export const updateTransportStatus = createAction(ACTION.UPDATE_TRANSPORT_STATUS.REQUEST);
